import {StyledCopyTrainingContainer, StyledCopyTrainingFormsWrapper, StyledCopyTrainingWrapper} from '../style'
import {ScrollArea} from '@/components/ui/scroll-area/ScrollArea'
import {Button} from '@/components/ui/button/Button'
import {Flexbox} from '@/components/ui/flexbox/FlexBox'
import {Settings01Icon} from '@/components/ui/icon/Icon'
import {Scrollbar} from '@/components/ui/scrollbar/Scrollbar'
import {useMerchCopyAi} from '@/features/ops-vetting/hooks/useMerchCopyAi'
import {useRef, useState} from 'react'
import {SubmitHandler} from 'react-hook-form'
import {useTranslation} from 'react-i18next'
import {AiPromptModal} from '@/components/commons/ai-prompt-modal/AiPromptModal'
import {EXPERIENCE_SHELL_PROMPT} from '@/features/ops-vetting/prompts/experienceShellPrompt'
import {OpsVettingHero} from '@/features/ops-vetting/components/ops-vetting-atoms/OpsVettingAtoms.tsx'
import {ExpShellMerchInputForm} from '@/features/experience-vetting/components/exp-shell-merch-input-form/ExpShellMerchInputForm'
import {
    ExperienceMerchandisingInputSchema,
    ExperienceShellMerchOutputSchema
} from '@/features/experience-vetting/formSchemas'
import {ExpShellMerchOutputForm} from '@/features/experience-vetting/components/exp-shell-merch-output-form/ExpShellMerchOutputForm'

export const ExpShellCopyTraining = () => {
    const {t} = useTranslation()
    const {
        aiResponse,
        isLoading: isAiLoading,
        onMerchCopyAiCall,
        resetAiResponse
    } = useMerchCopyAi<ExperienceShellMerchOutputSchema>()
    //submission refs
    const finalSubmitRef = useRef<HTMLButtonElement>(null)
    const aiSubmissionRef = useRef<HTMLButtonElement>(null)
    const [currentPrompt, setCurrentPrompt] = useState<string>(EXPERIENCE_SHELL_PROMPT)

    const handleAiSubmission: SubmitHandler<ExperienceMerchandisingInputSchema> = data => {
        resetAiResponse()
        onMerchCopyAiCall(data, currentPrompt)
    }

    return (
        <StyledCopyTrainingWrapper>
            <ScrollArea scrollbar={<Scrollbar />}>
                <StyledCopyTrainingContainer fullWidth>
                    <OpsVettingHero fullWidth justify="space-between" align="center">
                        <h3>Exp shell Copy Training</h3>
                        <Flexbox gap={2}>
                            <AiPromptModal
                                trigger={
                                    <Button variant="tertiary" size="sm" disabled={isAiLoading}>
                                        <Settings01Icon />
                                        {t('vetting:merch:commons:customize_prompt')}
                                    </Button>
                                }
                                currentPrompt={currentPrompt}
                                onPromptChange={newPrompt => setCurrentPrompt(newPrompt)}
                                isLoading={isAiLoading}
                                promptType="exp_shell"
                            />
                        </Flexbox>
                    </OpsVettingHero>

                    <StyledCopyTrainingFormsWrapper fullWidth>
                        <ExpShellMerchInputForm
                            isTraining={true}
                            isReadOnly={false}
                            defaultValues={{}}
                            aiResponse={aiResponse}
                            aiSubmissionRef={aiSubmissionRef}
                            handleAiSubmissionCb={handleAiSubmission}
                        />
                        <ExpShellMerchOutputForm
                            isTraining={true}
                            isReadOnly={false}
                            isHostEdits={false}
                            isLoading={isAiLoading}
                            defaultValues={aiResponse}
                            finalSubmitRef={finalSubmitRef}
                        />
                    </StyledCopyTrainingFormsWrapper>
                </StyledCopyTrainingContainer>
            </ScrollArea>
        </StyledCopyTrainingWrapper>
    )
}

ExpShellCopyTraining.displayName = 'ExpShellCopyTraining'
